module.exports = __webpack_public_path__ + "static/media/nissan-star.d6ff4bf9.svg";